// extracted by mini-css-extract-plugin
export default {"wrapper":"RoomList-module__wrapper","isVisible":"RoomList-module__isVisible","tab":"RoomList-module__tab","isActive":"RoomList-module__isActive","notice":"RoomList-module__notice"};